export default "__VITE_ASSET__D$zPOdBi__"